import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Alert } from '@ztechapps/webui.util'
import { CreateProductProposalGroup } from '../../CreateProductProposalGroup'
import type { ProductProposal } from '../../CreateProductProposalCard'

export type CreateProductProposalsProps = {
  proposals?: ProductProposal[]
}

/**
 * Adapter from the `createProduct` MCP tool result envelope to the shared
 * `CreateProductProposalGroup`. The MCP adapter aggregates every
 * `application/x-papi-product-proposal+json` resource into
 * `data.proposals[]`, and `ToolCallDisplay` strips the outer `data`
 * wrapper before passing props in — so this component receives the
 * proposals array directly.
 */
export const CreateProductProposals = ({ proposals }: CreateProductProposalsProps) => {
  if (isEmpty(proposals)) {
    return (
      <Alert type="info">
        <span className="text-body">No product proposals returned.</span>
      </Alert>
    )
  }
  return <CreateProductProposalGroup proposals={proposals ?? []} />
}
